





























import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import BaseInputFile from "@/components/BaseInputFile";
import DragDropFiles from "@/components/DragDropFiles";

@Component({ name: "EditPostDropZone", components: { BaseInputFile, DragDropFiles } })
export default class EditPostDropZone extends Vue {
  @Prop({ type: Boolean })
  public readonly multiple!: boolean;

  @Prop({ required: true })
  public readonly allowedFileTypes!: string[];

  @Prop({ type: Boolean, required: true })
  public readonly showDropZone!: boolean;
}
